import { USER_ACTION_TYPES } from '../reducers/userReducer';

/**
 * Set user details (login)
 * @param {Object} userData - User data object
 * @returns {Object} Action object
 */
export const setUser = (userData) => ({
  type: USER_ACTION_TYPES.SET_USER,
  payload: userData,
});

/**
 * Update user details
 * @param {Object} updates - Partial user data to update
 * @returns {Object} Action object
 */
export const updateUser = (updates) => ({
  type: USER_ACTION_TYPES.UPDATE_USER,
  payload: updates,
});

/**
 * Clear user (logout)
 * @returns {Object} Action object
 */
export const clearUser = () => ({
  type: USER_ACTION_TYPES.CLEAR_USER,
});
